import { Colors, mediaQueries } from '@fourthwall/components';
import styled from 'styled-components';
export const Container = styled.div `
  height: 100%;
  display: flex;
  overflow: hidden;

  ${mediaQueries.tablet} {
    height: 708px;
  }
`;
export const Sidebar = styled.div `
  width: 100%;
  height: 100%;
  padding: 16px 12px;
  background: ${Colors.GS200};
  display: flex;
  flex-direction: column;
  gap: 20px;

  ${mediaQueries.tablet} {
    width: 340px;
    padding: 24px 32px 28px;
  }
`;
export const TextualContent = styled.div `
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
export const Title = styled.div `
  font-size: 20px;
  font-weight: 600;
  line-height: 140%;

  ${mediaQueries.tablet} {
    font-size: 24px;
    line-height: 130%;
  }
`;
export const Description = styled.div `
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.14px;
`;
export const Content = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
`;
export const ModalHeader = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px 20px 20px;
  gap: 4px;
`;
export const CloseButton = styled.button.attrs({ type: 'button' }) `
  padding: 8px;
  position: relative;
  right: -8px;
`;
export const GuidesWrapper = styled.div `
  flex: 1;
  position: relative;
`;
